import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	updateInn,
	type UpdateInnErrorResponse,
	type UpdateInnRequest,
	type UpdateInnResponse,
} from '../../http';

export function useUpdateInn(
	options?: UseMutationOptions<UpdateInnResponse, AxiosError<UpdateInnErrorResponse>, UpdateInnRequest>,
): UseMutationResult<UpdateInnResponse, AxiosError<UpdateInnErrorResponse>, UpdateInnRequest> {
	const queryClient = useQueryClient();

	return useMutation<UpdateInnResponse, AxiosError<UpdateInnErrorResponse>, UpdateInnRequest>(
		(request) => updateInn(request).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
